<dx-popup
    [title]="'Rental Billing Line'"
    [width]="600"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="rentalBillingLine">
        <dxi-form-item [label]="{ text: 'Rental' }">
            <div *dxTemplate>
                <dx-select-box
                    [value]="rentalBillingLine.rentalId"
                    [items]="rentals"
                    displayExpr="displayName"
                    valueExpr="id"
                    [disabled]="true"
                ></dx-select-box>
            </div>
        </dxi-form-item>
        <dxi-form-item dataField="startDate" editorType="dxDateBox" [editorOptions]="{ type: 'date', width: '150px' }"> </dxi-form-item>
        <dxi-form-item dataField="endDate" editorType="dxDateBox" [editorOptions]="{ type: 'date', width: '150px' }"> </dxi-form-item>
        <dxi-form-item [label]="{ text: 'Rate' }">
            <div *dxTemplate>
                <dx-number-box [(value)]="rate" [format]="{ type: 'currency', precision: 2 }" width="150px"></dx-number-box>
            </div>
        </dxi-form-item>

        <dxi-form-item dataField="note" editorType="dxTextArea" [editorOptions]="{ height: '125px' }"> </dxi-form-item>
    </dx-form>
</dx-popup>
